<template>
  <div class="filter">
    <div class="level bottom">
      <div class="level-left"></div>
      <div class="level-right filter_actions">
        <button class="delete_course" @click="$emit('delete')" :disabled="!rows.checked.length" v-if="!search.archive">
          <i class="mdi mdi-check"></i> Прочитать выбранные
        </button>
        <button class="delete_course" @click="$emit('delete-all')">
          <i class="mdi mdi-check-all"></i> Прочитать все
        </button>
      </div>
    </div>
    <div class="level">
      <b-field label="Поиск по содержанию:" class="course_search input_search" type="is-info">
        <b-input v-model="search.text" placeholder="Введите текст"></b-input>
      </b-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      default: () => {},
      type: Object
    },
    search: {
      default: () => {},
      type: Object
    }
  }
}
</script>
